export default {
  en: {
    'components.filing-outcome.title': 'Filing Outcome',
    'components.filing-outcome.payment-details.button': 'Payment Details',
    'components.filing-outcome.payment-details-update.success':
      'Payment details updated successfully',
    'components.filing-outcome.net-vat': 'Net VAT',
    'components.filing-outcome.input-vat': 'Input VAT',
    'components.filing-outcome.output-vat': 'Output VAT',
    'components.filing-outcome.payment-details-update.fallback-error':
      'Error updating payment details, please try again.',
  },
};
